import { computed, ref, getCurrentInstance } from 'vue';
import { ENTITY_ITEMS_DROPDOWN_LIMIT } from '@/_legacy/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEntityTypeOfResponse(item: any) {
  const dropdownVisible = ref(false);
  const limit = ref(ENTITY_ITEMS_DROPDOWN_LIMIT);
  const multiple = computed(() => {
    return item.value.response && item.value.response.drawing
      ? item.value.response.drawing
      : null;
  });

  const inspection = computed<{
    entity_items: Record<string, string>;
    issues: Record<string, string>;
  }>(() => {
    return getCurrentInstance()
      ?.proxy
      ?.$store
      ?.getters['conduct/inspection'];
  });

  const showDropdown = () => {
    dropdownVisible.value = true;
  };

  const closeDropdown = () => {
    dropdownVisible.value = false;
  };

  return {
    dropdownVisible,
    limit,
    multiple,
    inspection,
    showDropdown,
    closeDropdown,
  };
}
